import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import './transferencias.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEye } from '@fortawesome/free-solid-svg-icons';
import { useUnits } from '../../context/unitsContext';
import { useInternals } from '../../context/internalContext';
import { useUsers } from '../../context/usersContext';
import Modal from '../../components/modal';
import ReactPaginate from 'react-paginate';
import Header from '../../components/header';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import X from '../../assets/icons/x.svg';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import ConfirmModal from '../../components/modal/confirmModal';
import { normalizeUnitId } from '../../utils/unitScope';
import useSubmitLock from '../../utils/useSubmitLock';
import InternalPhoto from '../../components/InternalPhoto';
import { localToday, localNowTime } from '../../utils/dateUtils';

const normalizeGroup = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim()
  .toUpperCase();

const normalizeText = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim()
  .toUpperCase();

const MONITORING_UNIT_NAME = 'Monitoramento Sec Justi\u00e7a Piau\u00ed';
const isMonitoringUnit = (unit) => normalizeText(unit?.name) === normalizeText(MONITORING_UNIT_NAME);

function CreateTransfer() {
  const {
    userInfo,
    effectiveUnitId,
    requireWriteUnit,
  } = useUsers();
  const { summaryListUnit, listUnits, listPavillions, listCells } = useUnits();
  const { listTransfers, createTransfer, acceptTransfer, rejectTransfer, cancelTransfer } = useInternals();


  const userUnitId = effectiveUnitId;
  const isDuapReadOnly = Array.isArray(userInfo?.groups)
    ? userInfo.groups.some((group) => {
      const normalized = normalizeGroup(group);
      return ['GERENTE DE UNIDADE', 'DIRETORES', 'DUAP'].some((target) => normalizeGroup(target) === normalized);
    })
    : false;

  const [units, setUnits] = useState([]);
  const [process, setProcess] = useState('');
  const [reason, setReason] = useState('');
  const [date, setDate] = useState('');
  const [recipient, setRecipient] = useState('');
  const [cells, setCells] = useState([]);
  const [selectedInternals, setSelectedInternals] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [isInternalModalOpen, setIsInternalModalOpen] = useState(false);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isAllTransfersModalOpen, setIsAllTransfersModalOpen] = useState(false);
  const [currentTransferDetails, setCurrentTransferDetails] = useState(null);
  const [currentTransfer, setCurrentTransfer] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [cell, setCell] = useState('');
  const [dateRecipient, setDateRecipient] = useState('');
  const [pavilions, setPavilions] = useState([]);
  const [selectedPavilion, setSelectedPavilion] = useState('');

  const [showTransfers, setShowTransfers] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const {
    isSubmitting: isTransferActionSubmitting,
    runWithSubmitLock: runWithTransferActionLock,
  } = useSubmitLock();

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filterUnit, setFilterUnit] = useState('');
  const [filterStatus, setFilterStatus] = useState('Todos');
  const [filterName, setFilterName] = useState('');
  const getUnitLabel = (unit) => unit?.acronym || unit?.unit_acronym || unit?.name || `Unidade ${unit?.id}`;
  const getCellPavilionId = (cellItem) => Number(
    cellItem?.pavilion?.id ?? cellItem?.pavilion_id ?? cellItem?.pavilion
  );
  const getInternalUnitId = (internal) => normalizeUnitId(
    internal?.unit?.id ?? internal?.unit_id ?? internal?.unit
  );
  const getUnitIdByLabel = (label) => {
    const normalizedLabel = normalizeText(label);
    if (!normalizedLabel) return null;

    const matchedUnit = units.find((unit) => {
      const candidates = [
        getUnitLabel(unit),
        unit?.name,
        unit?.acronym,
        unit?.unit_acronym,
      ]
        .map((value) => normalizeText(value))
        .filter(Boolean);

      return candidates.some((candidate) =>
        candidate === normalizedLabel ||
        candidate.includes(normalizedLabel) ||
        normalizedLabel.includes(candidate)
      );
    });

    return normalizeUnitId(matchedUnit?.id ?? null);
  };

  const getTransferSideUnitId = (transfer, side) => {
    const sideValue = transfer?.[side];

    const directCandidates = [
      transfer?.[`${side}_unit_id`],
      transfer?.[`${side}_unit`],
      sideValue?.unit_id,
      sideValue?.unit?.id,
      sideValue?.unit,
    ];

    for (const candidate of directCandidates) {
      const unitId = normalizeUnitId(candidate);
      if (unitId !== null) return unitId;
    }

    return getUnitIdByLabel(transfer?.[`${side}_name`]);
  };

  const hasActingUnit = userUnitId !== null && userUnitId !== undefined && String(userUnitId) !== '';
  const isTransferFromActingUnit = (transfer) => {
    if (!hasActingUnit) return false;
    const senderUnitId = getTransferSideUnitId(transfer, 'sender');
    return senderUnitId !== null && String(senderUnitId) === String(userUnitId);
  };
  const isTransferToActingUnit = (transfer) => {
    if (!hasActingUnit) return false;
    const recipientUnitId = getTransferSideUnitId(transfer, 'recipient');
    return recipientUnitId !== null && String(recipientUnitId) === String(userUnitId);
  };

  const handlePageClick = ({ selected }) => {
    fetchAllTransfers({ page: selected, limit: itemsPerPage, name: filterName });
  };

  // Abrir  sesao de criar  transferencia
  const toggleShowTransfer = () => {
    if (isDuapReadOnly) return;
    setShowTransfers(!showTransfers);
  };

  // Fetching unidades
  useEffect(() => {
    const fetchUnits = async () => {
      const summaryResponse = await summaryListUnit();
      let normalizedUnits = Array.isArray(summaryResponse)
        ? summaryResponse
        : summaryResponse?.message || summaryResponse?.results || [];

      if (!normalizedUnits.length) {
        const listResponse = await listUnits();
        normalizedUnits = Array.isArray(listResponse)
          ? listResponse
          : listResponse?.results || listResponse?.message || [];
      }

      setUnits(normalizedUnits);
    };
    fetchUnits();
  }, [summaryListUnit, listUnits]);

  const handleInternalSelect = (internal) => {
    if (selectedInternals.some(selected => selected.id === internal.id)) {
      toast.warning("Este interno já foi adicionado.");
      return;
    }

    setSelectedInternals((prev) => [...prev, internal]);
    setIsInternalModalOpen(false); // Fecha o modal após selecionar
  };

  const fetchPavilions = async (unitId) => {
    const response = await listPavillions({ unit: unitId });
    if (response && Array.isArray(response.results)) {
      const filteredPavilions = response.results.filter(
        (pavilion) => String(pavilion?.unit) === String(unitId)
      );
      setPavilions(filteredPavilions);
    } else {
      console.error("listPavillions não retornou um array válido", response);
      setPavilions([]);
    }
  };

  // Buscar transferências com paginação server-side
  const fetchAllTransfers = useCallback(async ({ page = 0, limit = 10, name = '' } = {}) => {
    try {
      const params = { limit, offset: page * limit };
      if (hasActingUnit) params.unit = userUnitId;
      if (name) params.internal_name = name;
      const response = await listTransfers(params);
      if (response && Array.isArray(response.results)) {
        setTransfers(response.results);
        setTotalCount(response.count || 0);
        setCurrentPage(page);
      } else {
        setTransfers([]);
        setTotalCount(0);
        setCurrentPage(0);
      }
    } catch (error) {
      console.error('Erro ao buscar transferências:', error);
    }
  }, [hasActingUnit, listTransfers, userUnitId]);

  useEffect(() => {
    fetchAllTransfers();
  }, [fetchAllTransfers]);

  const handlePavilionChange = async (pavilionId) => {
    setSelectedPavilion(pavilionId);
    setCell('');

    if (!pavilionId) {
      setCells([]);
      return;
    }

    const response = await listCells({ pavilion: pavilionId });
    if (response && Array.isArray(response.results)) {
      const normalizedPavilionId = Number(pavilionId);
      const filteredCells = response.results.filter(
        (cellItem) => getCellPavilionId(cellItem) === normalizedPavilionId
      );
      setCells(filteredCells);
    } else {
      console.error("listCells não retornou um array válido", response);
      setCells([]);
    }
  };


  // Remover interno da lista de transferência
  const removeInternalFromList = (internalId) => {
    setSelectedInternals((prev) => prev.filter(internal => internal.id !== internalId));
  };

  // Handle para submeter o formulário de transferência
  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }

      if (selectedInternals.length === 0) {
        toast.warning('Selecione ao menos um interno.');
        return;
      }

      const hasInternalsFromOtherUnit = selectedInternals.some((internal) => {
        const internalUnitId = getInternalUnitId(internal);
        if (internalUnitId === null) return false;
        return String(internalUnitId) !== String(writeUnit.unitId);
      });

      if (hasInternalsFromOtherUnit) {
        toast.warning('Existem internos fora da unidade de atuação selecionada.');
        return;
      }

      const transferData = selectedInternals.map(internal => ({
        process,
        reason,
        date: `${date}T00:00:00`,
        sender: internal.cell,
        recipient,
        internal: internal.id,
        received: false
      }));

      try {
        for (const data of transferData) {
          await createTransfer(data);
        }
        setSelectedInternals([]);
        setProcess('');
        setReason('');
        setDate('');
        setRecipient('');

        // Atualiza a lista unificada após criar transferências
        await fetchAllTransfers();
      } catch (error) {
        //erroja tratado no contexto
      }
    });
  };

  // Handle para aceitar transferência
  const handleAcceptTransfer = async (internalId) => {
    await runWithTransferActionLock(async () => {
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }

      if (!currentTransfer || !isTransferToActingUnit(currentTransfer)) {
        toast.warning('Transferência fora da unidade de atuação.');
        return;
      }

      // Validação: Se selectedPavilion, cell ou dateRecipient estiver vazio, mostra aviso e retorna
      if (!selectedPavilion || !cell) {
        toast.warning('Selecione pavilhão e cela antes de aceitar.');
        return;
      }
      if (!dateRecipient) {
        toast.warning('Informe a data de recebimento.');
        return;
      }
      try {
        // Backend exige date_recipient > date e date_recipient <= agora.
        // Se a data escolhida for hoje, manda o horário atual (sempre <= agora);
        // se for uma data passada, manda a última hora do dia (também sempre <= agora).
        const dateRecipientTime = dateRecipient === localToday() ? localNowTime() : '23:59:59';
        await acceptTransfer(internalId, cell, `${dateRecipient}T${dateRecipientTime}`);
        setIsTransferModalOpen(false);
        // Atualiza a lista unificada
        await fetchAllTransfers();
      } catch (error) {
        // Erro já tratado no contexto
      }
    });
  };

  // Handle para recusar transferência
  const handleRejectTransfer = async (internalId) => {
    await runWithTransferActionLock(async () => {
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }

      if (!currentTransfer || !isTransferToActingUnit(currentTransfer)) {
        toast.warning('Transferência fora da unidade de atuação.');
        return;
      }

      if (!rejectReason) {
        toast.warning('Informe o motivo da recusa.');
        return;
      }
      try {
        await rejectTransfer(internalId, rejectReason);
        setIsTransferModalOpen(false);
        // Atualiza a lista unificada
        await fetchAllTransfers();
        setRejectReason('');
      } catch (error) {
        // Erro já tratado no contexto
      }
    });
  };

  // Cancelar transferência com confirmação
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  const [transferToCancel, setTransferToCancel] = useState(null);

  const handleCancelTransfer = (transferId) => {
    setTransferToCancel(transferId);
    setIsConfirmModalOpen(true);
  };

  const handleConfirmCancel = async () => {
    if (!transferToCancel) return;

    const writeUnit = requireWriteUnit();
    if (!writeUnit.ok) {
      toast.warning(writeUnit.message);
      return;
    }

    const transferData = transfers.find((item) => String(item.id) === String(transferToCancel));
    if (!transferData || !isTransferFromActingUnit(transferData)) {
      toast.warning('Transferência fora da unidade de atuação.');
      return;
    }

    setLoadingConfirm(true);
    try {
      await cancelTransfer(transferToCancel);
      setIsTransferModalOpen(false);
      await fetchAllTransfers();
    } catch (error) {
      // Erro já tratado no contexto
    }
    setLoadingConfirm(false);
    setIsConfirmModalOpen(false);
    setTransferToCancel(null);
  };

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setTransferToCancel(null);
  };

  // Abrir modal de transferência
  const openTransferModal = (transfer) => {
    if (isDuapReadOnly) {
      openAllTransfersModal(transfer);
      return;
    }

    if (!hasActingUnit) {
      toast.warning('Selecione uma unidade de atuação para executar ações de transferência.');
      openAllTransfersModal(transfer);
      return;
    }

    setCurrentTransfer(transfer);
    setIsTransferModalOpen(true);
    setSelectedPavilion('');
    setCell('');
    setDateRecipient(localToday());
    setCells([]);
    fetchPavilions(userUnitId);
  };

  // Fechar modal de transferência
  const closeTransferModal = () => {
    setIsTransferModalOpen(false);
    setCurrentTransfer(null);
    setRejectReason('');
    setCell('');
    setDateRecipient('');
    setPavilions([]);
    setSelectedPavilion('');
    setCells([]);
  };

  // Abrir modal de todos os detalhes da transferência
  const openAllTransfersModal = (transfer) => {
    setCurrentTransferDetails(transfer);
    setIsAllTransfersModalOpen(true);
  };

  // Fechar modal de todos os detalhes da transferência
  const closeAllTransfersModal = () => {
    setIsAllTransfersModalOpen(false);
    setCurrentTransferDetails(null);
  };

  useEffect(() => {
    setSelectedInternals([]);
    setSelectedPavilion('');
    setCell('');
    setDateRecipient('');
    setPavilions([]);
    setCurrentTransfer(null);
    setIsTransferModalOpen(false);
  }, [userUnitId]);

  // Debounce: re-fetch no servidor quando filterName muda (mínimo 3 letras ou vazio)
  useEffect(() => {
    if (filterName.length > 0 && filterName.length < 3) return;
    const timer = setTimeout(() => {
      fetchAllTransfers({ page: 0, limit: itemsPerPage, name: filterName });
    }, 400);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterName]);

  // Filtros client-side e ordenação personalizada
  const getFilteredTransfers = () => {
    let filtered = [...transfers];
    if (startDate) {
      filtered = filtered.filter(t => new Date(t.date) >= new Date(startDate));
    }
    if (endDate) {
      filtered = filtered.filter(t => new Date(t.date) <= new Date(endDate));
    }
    if (filterUnit) {
      filtered = filtered.filter(t =>
        (t.sender_name && t.sender_name === filterUnit) ||
        (t.recipient_name && t.recipient_name === filterUnit)
      );
    }
    if (filterStatus && filterStatus !== 'Todos') {
      filtered = filtered.filter(t => {
        if (filterStatus === 'Pendente') {
          return (t.is_active === 1 || t.is_active === true) && !t.received;
        }
        if (filterStatus === 'Realizada') {
          return (t.is_active === 0 || t.is_active === false) && t.received;
        }
        if (filterStatus === 'Recusada') {
          return (t.is_active === 0 || t.is_active === false) && !t.received;
        }
        return true;
      });
    }
    // Ordenar: pendentes primeiro, depois restantes por data desc
    filtered.sort((a, b) => {
      const aPending = (a.is_active === 1 || a.is_active === true) && !a.received;
      const bPending = (b.is_active === 1 || b.is_active === true) && !b.received;
      if (aPending && !bPending) return -1;
      if (!aPending && bPending) return 1;
      // Ambos pendentes ou ambos não pendentes: ordenar por data desc para não-pendentes
      if (!aPending && !bPending) {
        return new Date(b.date) - new Date(a.date);
      }
      // Se ambos pendentes, manter a ordem original
      return 0;
    });
    return filtered;
  };

  const filteredTransfers = getFilteredTransfers();
  const pageCount = Math.ceil(totalCount / itemsPerPage);
  const selectableUnits = units.filter((unit) => !isMonitoringUnit(unit));

  const resetFilters = () => {
    setStartDate('');
    setEndDate('');
    setFilterUnit('');
    setFilterStatus('Todos');
    setFilterName('');
    fetchAllTransfers({ page: 0, limit: itemsPerPage });
  };

  // Formata a data para o formato brasileiro
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const getTransferInternalInitials = (transfer) => {
    const name = String(transfer?.internal_name || '').trim();
    if (!name) return 'IN';

    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
  };

  const renderTransferProfile = (transfer) => {
    return (
      <div className="transfer-profile-card">
        <div className="transfer-profile-top">
          <div className="transfer-profile-avatar">
            {/* A transferência traz a foto em `image` (registro de internalimage ou null) */}
            <InternalPhoto internal={transfer} preferThumbnail alt={`Foto de ${transfer?.internal_name || 'interno'}`}>
              <span className="transfer-profile-avatar-fallback">{getTransferInternalInitials(transfer)}</span>
            </InternalPhoto>
          </div>

          <div className="transfer-profile-content">
            <h3>{transfer?.internal_name || '-'}</h3>
            <div className="transfer-profile-meta">
              <span className="transfer-profile-chip">Data: {formatDate(transfer?.date)}</span>
              {transfer?.received && transfer?.date_recipient && (
                <span className="transfer-profile-chip">
                  Data de recebimento: {formatDate(transfer.date_recipient)}
                </span>
              )}
              <div className="transfer-profile-status">
                <span className="transfer-profile-status-label">Status:</span>
                {renderStatus(transfer)}
              </div>
            </div>
          </div>
        </div>

        <div className="transfer-flow-block">
          <p className="transfer-profile-subtitle">Fluxo da transferência</p>
          <div className="transfer-profile-route-board">
            <div className="transfer-route-card transfer-route-origin">
              <span className="transfer-route-label">Origem</span>
              <strong>{transfer?.sender_name || '-'}</strong>
            </div>
            <div className="transfer-route-divider" aria-hidden="true">
              <span className="transfer-route-line"></span>
              <span className="transfer-route-arrow">→</span>
              <span className="transfer-route-line"></span>
            </div>
            <div className="transfer-route-card transfer-route-destination">
              <span className="transfer-route-label">Destino</span>
              <strong>{transfer?.recipient_name || '-'}</strong>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Função para renderizar o status
  const renderStatus = (transfer) => {
    if ((transfer.is_active === 1 || transfer.is_active === true) && !transfer.received) {
      return <span className="status-vermelho">Pendente</span>;
    }
    if ((transfer.is_active === 0 || transfer.is_active === false) && transfer.received) {
      return <span className="status-verde">Realizada</span>;
    }
    if ((transfer.is_active === 0 || transfer.is_active === false) && !transfer.received && transfer.no_receipt) {
      return <span className="status-amarelo">Recusada</span>;
    }
    if ((transfer.is_active === 0 || transfer.is_active === false) && !transfer.received && !transfer.no_receipt) {
      return <span className="status-azul">Cancelada</span>;
    }
    return null;
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <div className="admission-header">
          <div className="admission-title">
            <h2>Transferências entre Unidades</h2>
            <p>Gestão e controle de transferências internas.</p>
          </div>
          <div className="admission-actions">
            <button onClick={resetFilters} className='btn-reset btnAdcionar'>
              Limpar filtros<img src={X} alt='icone' className='icon' />
            </button>
            {!isDuapReadOnly && (
              <button onClick={toggleShowTransfer} className='btnAdcionar'>
                {showTransfers ? (
                  <>
                    <img src={X} alt='icone' className='icon' /> Cancelar Criação
                  </>
                ) : (
                  <>
                    <img src={PlusCircle} alt='icone' className='icon' /> Criar transferência
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        {/* Formulário de Criação de Transferência */}
        {showTransfers && (
          <div className={`container-transfer container-animation ${showTransfers ? 'show' : 'hide'}`}>
            <form onSubmit={handleSubmit} className="transfer-unit-form">
              <div className="health-card">
                <h4 className='h4-title'>Dados da transferência</h4>
                <div className="health-grid-two">
                  <div className="health-option-set">
                    <label>Numero do documento</label>
                    <input
                      type="text"
                      value={process}
                      placeholder='Ex: numero de oficio'
                      onChange={(e) => setProcess(e.target.value)}
                      required
                    />
                  </div>
                  <div className="health-option-set">
                    <label>Data da transferência</label>
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      required
                    />
                  </div>
                  <div className="health-option-set">
                    <label>Unidade de destino</label>
                    <select
                      value={recipient}
                      onChange={(e) => setRecipient(e.target.value)}
                      required
                    >
                      <option value="">Selecione a unidade de destino</option>
                      {selectableUnits.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {getUnitLabel(unit)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="health-option-set" style={{ marginTop: 12 }}>
                  <label>Razão da transferência</label>
                  <textarea
                    value={reason}
                    placeholder='Descreva a razão aqui'
                    onChange={(e) => setReason(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="health-card">
                <div className="change-cell-actions">
                  <button type="button" onClick={() => setIsInternalModalOpen(true)} className='btnAdcionar'>
                    <img src={PlusCircle} alt='icone' className='icon' /> Adicionar interno
                  </button>
                </div>
                <div className="internals-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Unidade Atual</th>
                        <th>Pavilhão Atual</th>
                        <th>Cela Atual</th>
                        <th>Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedInternals.map((internal) => (
                        <tr key={internal.id}>
                          <td>{internal.name}</td>
                          <td>{internal.unit_name}</td>
                          <td>{internal.pavilion_name}</td>
                          <td>{internal.cell_name}</td>
                          <td>
                            <button
                              type="button"
                              className="change-cell-remove"
                              onClick={() => removeInternalFromList(internal.id)}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button type="submit" className='btnTransfer btnConfirmar ' disabled={isSubmitting}>
                  <FontAwesomeIcon icon={faCheck} />
                  <span>{isSubmitting ? 'Salvando...' : 'Confirmar transferência'}</span>
                </button>

              </div>
            </form>
          </div>
        )}

        {/* Seção de Filtros */}
        {!showTransfers && (
          <div className='content-filters'>
            <div className="health-card">
              <div className="health-grid-two">
                <div className='filter-group'>
                  <label className='h4-title'>Nome do interno</label>
                  <input
                    type="text"
                    value={filterName}
                    placeholder="Pesquisar por nome"
                    onChange={(e) => setFilterName(e.target.value)}
                  />
                </div>
                <div className='filter-group'>
                  <label className='h4-title'>Data de início</label>
                  <input type="date" value={startDate} onChange={(e) => { setStartDate(e.target.value); setCurrentPage(0); }} />
                </div>
                <div className='filter-group'>
                  <label className='h4-title'>Data de término</label>
                  <input type="date" value={endDate} onChange={(e) => { setEndDate(e.target.value); setCurrentPage(0); }} />
                </div>
                <div className='filter-group'>
                  <label className='h4-title'>Unidade</label>
                  <select value={filterUnit} onChange={(e) => { setFilterUnit(e.target.value); setCurrentPage(0); }}>
                    <option value="">Todos</option>
                    {selectableUnits.map((unit) => (
                      <option key={unit.id} value={getUnitLabel(unit)}>
                        {getUnitLabel(unit)}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='filter-group'>
                  <label className='h4-title'>Status</label>
                  <select value={filterStatus} onChange={(e) => { setFilterStatus(e.target.value); setCurrentPage(0); }}>
                    <option value="Todos">Todos</option>
                    <option value="Pendente">Pendente</option>
                    <option value="Realizada">Realizada</option>
                    <option value="Recusada">Recusada</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Tabela única de transferências */}
            <div className='trasfer-table content-table'>
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                {filteredTransfers.length > 0 ? (
                  <tbody>
                    {filteredTransfers.map((transfer) => (
                        <tr key={transfer.id}>
                          <td className='td-limited'>{transfer.internal_name}</td>
                          <td className='td-limited'>{transfer.sender_name}</td>
                          <td className='td-limited'>{transfer.recipient_name}</td>
                          <td>{renderStatus(transfer)}</td>
                          <td>
                            {(!isDuapReadOnly && hasActingUnit && !transfer.received && transfer.is_active) ? (
                              <button onClick={() => openTransferModal(transfer)}>
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                            ) : (
                              <button onClick={() => openAllTransfersModal(transfer)}>
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={6}><p>Nenhuma transferência encontrada</p></td>
                    </tr>
                  </tbody>
                )}
              </table>
              {pageCount > 0 && (
                <div className="pagination-options">
                  <div>
                    <label htmlFor="transfers-per-page">Itens por página:</label>
                    <select
                      id="transfers-per-page"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const newLimit = Number(e.target.value);
                        setItemsPerPage(newLimit);
                        fetchAllTransfers({ page: 0, limit: newLimit, name: filterName });
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    activeClassName={'activeNumber'}
                    previousClassName={'prev'}
                    nextClassName={'next'}
                    pageClassName={'page'}
                    breakClassName={'break-me'}
                    forcePage={currentPage}
                  />
                </div>
              )}
            </div>
          </div>
        )}


        {/* Modal para adicionar internos na transferência */}
        {isInternalModalOpen && (
          <Modal title="Adicionar Interno" isOpen={isInternalModalOpen} closeModal={() => setIsInternalModalOpen(false)}>
            <SearchInternal onSelect={handleInternalSelect} />
          </Modal>
        )}

        {/* Modal para aceitar/recusar transferências */}
        {isTransferModalOpen && currentTransfer && (
          <Modal title="Detalhes da Transferência" isOpen={isTransferModalOpen} closeModal={closeTransferModal}>
            <form className="transfer-modal">
              {renderTransferProfile(currentTransfer)}

              <div className="transfer-modal-grid">
                <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-process">
                  <span>Processo</span>
                  <strong>{currentTransfer.process || '-'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-reason">
                  <span>Razão</span>
                  <strong>{currentTransfer.reason || '-'}</strong>
                </div>
              </div>

              {isTransferFromActingUnit(currentTransfer) && (
                <div className="transfer-modal-actions">
                  <button
                    type="button"
                    className="btnConfirmar danger"
                    onClick={() => handleCancelTransfer(currentTransfer.id)}
                  >
                    Cancelar transferência
                  </button>
                </div>
              )}

              {isTransferToActingUnit(currentTransfer) && (
                <>
                  <div className="transfer-modal-block">
                    <div className="transfer-modal-grid">
                      <div className="transfer-modal-input">
                        <label>Escolha o Pavilhão</label>
                        <select value={selectedPavilion} onChange={(e) => handlePavilionChange(e.target.value)} required>
                          <option value="">Selecione o pavilhão</option>
                          {pavilions.map((pavilion) => (
                            <option key={pavilion.id} value={pavilion.id}>{pavilion.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="transfer-modal-input">
                        <label>Escolha a Cela</label>
                        <select value={cell} onChange={(e) => setCell(e.target.value)} required>
                          <option value="">Selecione a cela</option>
                          {cells.map((cell) => (
                            <option key={cell.id} value={cell.id}>{cell.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="transfer-modal-input">
                        <label>Data de recebimento</label>
                        <input
                          type="date"
                          value={dateRecipient}
                          max={localToday()}
                          onChange={(e) => setDateRecipient(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="transfer-modal-input">
                    <label>Motivo da recusa</label>
                    <textarea value={rejectReason} required onChange={(e) => setRejectReason(e.target.value)} />
                  </div>

                  <div className="transfer-modal-actions">
                    <button
                      type="button"
                      className="btnConfirmar"
                      onClick={() => handleAcceptTransfer(currentTransfer.internal)}
                      disabled={isTransferActionSubmitting}
                    >
                      {isTransferActionSubmitting ? 'Processando...' : 'Aceitar'}
                    </button>
                    <button
                      type="button"
                      className="btnConfirmar danger"
                      onClick={() => handleRejectTransfer(currentTransfer.internal)}
                      disabled={isTransferActionSubmitting}
                    >
                      {isTransferActionSubmitting ? 'Processando...' : 'Recusar'}
                    </button>
                  </div>
                </>
              )}
            </form>
          </Modal>
        )}

        {/* Detalhes da transferência */}
        {isAllTransfersModalOpen && currentTransferDetails && (
          <Modal title="Detalhes da Transferência" isOpen={isAllTransfersModalOpen} closeModal={closeAllTransfersModal}>
            <form className="transfer-modal">
              {renderTransferProfile(currentTransferDetails)}

              <div className="transfer-modal-grid">
                <div className="transfer-modal-field transfer-modal-field-process">
                  <span>Processo</span>
                  <strong>{currentTransferDetails.process || '-'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-reason">
                  <span>Razão da transferência</span>
                  <strong>{currentTransferDetails.reason || '-'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-flag">
                  <span>Transferência ativa</span>
                  <strong>{currentTransferDetails.is_active ? 'Sim' : 'Não'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-flag">
                  <span>Foi recebido</span>
                  <strong>{currentTransferDetails.received ? 'Sim' : 'Não'}</strong>
                </div>
                {currentTransferDetails.no_receipt && (
                  <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-reason">
                    <span>Motivo da recusa</span>
                    <strong>{currentTransferDetails.no_receipt}</strong>
                  </div>
                )}
              </div>
            </form>
          </Modal>
        )}

        {/* Modal de confirmação para cancelar transferência */}
        <ConfirmModal
          isOpen={isConfirmModalOpen}
          closeModal={closeConfirmModal}
          onConfirm={handleConfirmCancel}
          mainMessage="Deseja realmente cancelar a transferência?"
          secondaryMessage="Essa ação não pode ser desfeita."
          loading={loadingConfirm}
        />
      </div>
    </div >
  );
}

export default CreateTransfer;
